var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-box"},[(_vm.dataList)?_c('div',{domProps:{"innerHTML":_vm._s(_vm.dataList)}}):_c('coustmEmpty')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }